'use client';

import algoliasearch from 'algoliasearch/lite';
import { InstantSearch } from 'react-instantsearch-hooks-web';
import SearchPageContent from './SearchPageContent.client';

const searchClient = algoliasearch(
  process.env.ALGOLIA_APPID,
  process.env.ALGOLIA_SEARCH_APIKEY
);

export default function SearchPage() {
  return (
    <InstantSearch
      searchClient={searchClient}
      indexName={process.env.SANITY_DATASET ?? 'preproduction'}
    >
      <SearchPageContent />
    </InstantSearch>
  );
}
